module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"No shop found within the displayed area"},"ja":{"message":"表示範囲内では店舗が見つかりませんでした"}}')
  delete Component.options._Ctor
}
